export var breadcrumbs = {
    margin: 0,
    padding: 0,
    fontSize: '.875em',
    lineHeight: '1.15em',
    marginTop: '1em',
    marginBottom: '1em',
    listStyle: 'none',
    '&::before, &::after': {
        display: 'table',
        content: '""',
    },
    '&::after': {
        clear: 'both',
    },
};
export var breadcrumbsItem = function (isBlackFriday) {
    var color = isBlackFriday ? 'white' : 'link';
    return {
        float: 'left',
        marginBottom: 0,
        color: color,
        '&::before': {
            display: 'inline-block',
            margin: '0 0.35em',
            fontSize: '1.4em',
            fontWeight: 'normal',
            content: '"\u203A"',
            verticalAlign: 'text-top',
            color: color,
        },
        '&:first-child::before': {
            width: 0,
            margin: 0,
            content: '""',
        },
        '&:last-child': {
            fontWeight: 'bold',
            color: 'uswitch-navy',
        },
    };
};
export var breadcrumbsLink = function (isBlackFriday) {
    var color = isBlackFriday ? 'white' : 'link';
    return {
        color: color,
        textDecoration: 'none',
        '&:visited': {
            color: color,
        },
        '&:hover': {
            color: color,
            textDecoration: 'underline',
        },
    };
};
//# sourceMappingURL=styles.js.map